<div mat-dialog-content class="pa-6 pb-0 mb-2 mt-2 text-center rounded">
	<i class="confirm__dialog__icon far fa-info-circle"></i>
	<h2 class="confirm__dialog__title mt-4 mb-0">{{ data.title }}</h2>
	<p class="confirm__dialog__description mt-2">{{ data.message }}</p>
</div>
<div mat-dialog-actions class="justify-content-center px-5 mb-3">
	<button
		class="confirm__dialog__btn btn btn-primary btn-lg rounded-pill"
		style="margin-right: 10px"
		(click)="closeDialog()"
		[mat-dialog-close]="true">
		<i class="fal fa-check-circle"></i> {{ data.titleConfirmButton }}
	</button>
	<button
		class="confirm__dialog__btn btn btn-outline-secondary btn-lg rounded-pill"
		(click)="closeDialog()"
		[mat-dialog-close]="false">
		<i [ngClass]="data.iconCancelButton"></i> {{ data.titleCancelButton }}
	</button>
</div>
